import userService from '../services/UserService';

export const USER_FETCH_REQUEST = 'USER_FETCH_REQUEST';
export const USER_FETCH_SUCCESS = 'USER_FETCH_SUCCESS';
export const USER_FETCH_FAILURE = 'USER_FETCH_FAILURE';

export const fetchUser = (id) => async (dispatch, getState) => {
    if (!id || id === 'my') {
        return dispatch({type: USER_FETCH_SUCCESS, user: getState().auth.user});
    }
    dispatch({type: USER_FETCH_REQUEST, id});
    try {
        const user = await userService.getUser(id);
        return dispatch({type: USER_FETCH_SUCCESS, user});
    } catch (error) {
        return dispatch({type: USER_FETCH_FAILURE, id, error});
    }
};

export const USER_SAVE_REQUEST = 'USER_SAVE_REQUEST';
export const USER_SAVE_SUCCESS = 'USER_SAVE_SUCCESS';
export const USER_SAVE_FAILURE = 'USER_SAVE_FAILURE';

export const onSaveUser = (data) => async (dispatch) => {
    const {id} = data;
    dispatch({type: USER_SAVE_REQUEST, id});
    try {
        const user = await userService.persistUser(data);
        const successNotification = 'User saved successfully';
        return dispatch({type: USER_SAVE_SUCCESS, id: user.id, successNotification});
    } catch (error) {
        return dispatch({type: USER_SAVE_FAILURE, id, error, errorNotification: 'An error occurred when saving the user'});
    }
};

export const USER_DELETE_REQUEST = 'USER_DELETE_REQUEST';
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS';
export const USER_DELETE_FAILURE = 'USER_DELETE_FAILURE';

export const onDeleteUser = (id) => async (dispatch) => {
    dispatch({type: USER_DELETE_REQUEST, id});
    try {
        await userService.deleteUser(id);
        return dispatch({type: USER_DELETE_SUCCESS, id});
    } catch (error) {
        return dispatch({type: USER_DELETE_FAILURE, id, error});
    }
};

export const USERS_FETCH_REQUEST = 'USERS_FETCH_REQUEST';
export const USERS_FETCH_SUCCESS = 'USERS_FETCH_SUCCESS';
export const USERS_FETCH_FAILURE = 'USERS_FETCH_FAILURE';

export const fetchUsers = () => async (dispatch) => {
    dispatch({type: USERS_FETCH_REQUEST});
    try {
        const users = await userService.getUsers();
        return dispatch({type: USERS_FETCH_SUCCESS, users});
    } catch (error) {
        return dispatch({type: USERS_FETCH_FAILURE, error});
    }
};



// WEBPACK FOOTER //
// ./src/actions/UserActions.js